module.exports = __webpack_public_path__ + "img/mercedes-eqc-page-gal-2.b94af05d.jpg";